/*
 * @Author: LiuLiXue QQ:136890965
 * @Date: 2017-12-26 09:50:25
 * @Last Modified by: LiuLiXue
 * @Last Modified time: 2017-12-28 09:47:20
 */
import fetch from '@/utils/fetch.js';
import {shop_url} from '@/global';
// 获取用户列表
const getUserList = (page=1, pageCount=10) => {
  const url = `${shop_url}/shop/cms/cmsuser/${page}/${pageCount}`;
  return fetch({
    url
  })
}
// 删除用户
const deleteUser = (userId,status=2) => {
  const url = `${shop_url}/shop/cms/cmsUser`;
  const data = {
    userId,
    status
  };
  const method = 'delete';
  return fetch({
    url,
    method,
    data
  })
}
//添加用户接口
const addCmsUser = (data = {},edit=false) => {
  const url = `${shop_url}/shop/cms/cmsuser`;
  let method = 'post';
  if(edit) {
    method = 'put';
  }
  return fetch({
    method,
    url,
    data
  })
}
// 修改用户权限
const setUserPre = (data={}) => {
  const url = `${shop_url}/shop/cms/cmsuserRight`;
  const method = 'put';
  return fetch({
    url,
    method,
    data
  })
}

// 获得角色列表
const getRole = ({page=1, pageCount=10} = {}) => {
  const url = `${shop_url}/shop/cms/smartPark/role/${page}/${pageCount}`;
  return fetch({
    url
  })
}


// 查询用户对应的菜单
const getMenu = userId => {
  const url = `${shop_url}/shop/cms/cmsUser/usermenu/${userId}`;
  return fetch({
    url
  })
}

export {
  getUserList,
  addCmsUser,
  getRole,
  deleteUser,
  setUserPre,
  getMenu
}



// WEBPACK FOOTER //
// ./src/api/permission/userManage.js